import axios from 'axios';
import { addressToTokenInfo, LIVECOINWATCH_API_KEY, CACHE_DURATION } from '../config/constants';
import { sleep } from '../utils/helpers';

// Simple in-memory cache for prices
const priceCache = {};

export async function getAllTokenPrices() {
  const entries = Object.entries(addressToTokenInfo);
  const prices = {};
  const concurrency = 8;

  // Session cache (browser) to persist for the session with TTL
  const ssKey = 'meowfi_prices_v1';
  try {
    const cached = JSON.parse(sessionStorage.getItem(ssKey) || 'null');
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      return cached.prices;
    }
  } catch {}

  let index = 0;
  async function worker() {
    while (index < entries.length) {
      const current = index++;
      const [addr, tokenInfo] = entries[current];
      const cacheKey = tokenInfo.symbol;
      if (priceCache[cacheKey] && Date.now() - priceCache[cacheKey].timestamp < CACHE_DURATION) {
        prices[addr.toLowerCase()] = { usd: priceCache[cacheKey].price };
        continue;
      }
      try {
        const response = await axios.post(
          'https://api.livecoinwatch.com/coins/single',
          { currency: 'USD', code: tokenInfo.symbol, meta: false },
          { headers: { 'content-type': 'application/json', 'x-api-key': LIVECOINWATCH_API_KEY }, timeout: 15000 }
        );
        if (response.data && response.data.rate) {
          prices[addr.toLowerCase()] = { usd: response.data.rate };
          priceCache[cacheKey] = { price: response.data.rate, timestamp: Date.now() };
        } else {
          prices[addr.toLowerCase()] = { usd: 0 };
        }
      } catch {
        prices[addr.toLowerCase()] = { usd: 0 };
      }
      // light pacing to avoid bursts
      await sleep(50);
    }
  }

  await Promise.all(Array.from({ length: Math.min(concurrency, entries.length) }, () => worker()));
  try {
    sessionStorage.setItem(ssKey, JSON.stringify({ prices, timestamp: Date.now() }));
  } catch {}
  return prices;
}
